import styles from "./Popup.module.css";

const Popup = ({ isOpen, onClose }) => {
  if (!isOpen) return null; // Don't render if not open

  const handleLinkClick = () => {
    onClose(); // Close popup when the link is clicked
    window.open("https://petnext-dev.web.app/login", "_blank"); 
  };

  return (
    <div className={styles.popupBackdrop}>
      <div className={styles.card} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>
          <img className={styles.popupImg} src="/assets/img/popup/closepopup.png" alt="close" />
        </button>
        <div className={styles.overlay}>
          <img src={"/assets/img/popup/dogwithhuman.png"} className="object-fit-cover p-2" alt="breeder" />
          <h5 className={styles.title}>ペット探しをもっと便利に</h5>
          <p className={styles.description}>
            新規アカウントのご登録で、お気に入り機能やブリーダーさんへのお問い合わせが可能です。
          </p>
          <a className={styles.button} onClick={handleLinkClick}>新規登録はこちら</a> 
        </div>
      </div>
    </div>
  );
};

export default Popup;
